module App.Interfaces {
    export interface ICarInformation {
        brand: string;
        type: string;
        constructionYear: number;
        fuelType: string;
        found: boolean;
        customCarDescription:string;
    }
}